export default __webpack_public_path__ + "static/media/comfy_card.917ccce0.svg";